import React, { useEffect, useState, useCallback, useMemo } from "react";
import { useSelector } from "react-redux";

const SocialModal = React.memo(() => {
  const { user } = useSelector((state) => state.user);

  const parseSocialMedias = useCallback(() => {
    const socials = user?.data?.social_medias || [];
    return {
      linkedin:
        socials
          .find((s) => s.includes("linkedin:"))
          ?.replace("linkedin:", "") || "",
      instagram:
        socials
          .find((s) => s.includes("instagram:"))
          ?.replace("instagram:", "") || "",
      github:
        socials.find((s) => s.includes("github:"))?.replace("github:", "") || "",
      behance:
        socials
          .find((s) => s.includes("behance:"))
          ?.replace("behance:", "") || "",
    };
  }, [user?.data?.social_medias]);

  const initialSocialState = useMemo(() => parseSocialMedias(), [parseSocialMedias]);

  const [socialState, setSocialState] = useState(initialSocialState);

  useEffect(() => {
    setSocialState(parseSocialMedias());
  }, [parseSocialMedias]);

  const handleInstagramChange = useCallback((e) => {
    setSocialState((prev) => ({
      ...prev,
      instagram: e.target.value,
    }));
  }, []);

  const handleLinkedinChange = useCallback((e) => {
    setSocialState((prev) => ({
      ...prev,
      linkedin: e.target.value,
    }));
  }, []);

  const handleGithubChange = useCallback((e) => {
    setSocialState((prev) => ({
      ...prev,
      github: e.target.value,
    }));
  }, []);

  const handleBehanceChange = useCallback((e) => {
    setSocialState((prev) => ({
      ...prev,
      behance: e.target.value,
    }));
  }, []);

  return (
    <div>
      <div className="form-group">
        <label htmlFor="instagram" className="label-edit">
          Instagram Link
        </label>
        <input
          className="custom-input w-full px-4"
          placeholder="Instagram linki giriniz"
          id="instagram"
          name="instagram"
          type="url"
          value={socialState.instagram}
          onChange={handleInstagramChange}
        />
      </div>
      <div className="form-group mt-4">
        <label htmlFor="linkedin" className="label-edit">
          LinkedIn Link
        </label>
        <input
          className="custom-input w-full px-4"
          placeholder="LinkedIn linki giriniz"
          id="linkedin"
          name="linkedin"
          type="url"
          value={socialState.linkedin}
          onChange={handleLinkedinChange}
        />
      </div>
      <div className="form-group mt-4">
        <label htmlFor="github" className="label-edit">
          GitHub Link
        </label>
        <input
          className="custom-input w-full px-4"
          placeholder="GitHub linki giriniz"
          id="github"
          name="github"
          type="url"
          value={socialState.github}
          onChange={handleGithubChange}
        />
      </div>
      <div className="form-group mt-4">
        <label htmlFor="behance" className="label-edit">
          Behance Link
        </label>
        <input
          className="custom-input w-full px-4"
          placeholder="Behance linki giriniz"
          id="behance"
          name="behance"
          type="url"
          value={socialState.behance}
          onChange={handleBehanceChange}
        />
      </div>
    </div>
  );
});

export default SocialModal;
